export const AUTH_IN_PROGRESS = 'AUTH_IN_PROGRESS';
export const AUTH_SECCESS = 'AUTH_SECCESS';
export const AUTH_ERROR = 'AUTH_ERROR';

export const GET_LAYOUT_STATIC_DATA_IN_PROGRESS = 'GET_LAYOUT_STATIC_DATA_IN_PROGRESS';
export const GET_LAYOUT_STATIC_DATA_SECCESS = 'GET_LAYOUT_STATIC_DATA_SECCESS';
export const GET_LAYOUT_STATIC_ERROR = 'GET_LAYOUT_STATIC_ERROR';

export const SEND_PAYMENT_IN_PROGRESS = 'SEND_PAYMENT_IN_PROGRESS';
export const SEND_PAYMENT_RESPONSE = 'SEND_PAYMENT_RESPONSE';
export const SEND_PAYMENT_ERROR = 'SEND_PAYMENT_ERROR';
